// @flow
import React from 'react';
import { connect } from 'react-redux';
import {
  MdExitToApp,
} from 'react-icons/lib/md';
import { actions as jwtActions } from 'nozzmo-redux-jwt';

import PopMenu from '../../PopMenu';
import NavbarButton from '../NavbarButton';
import NavbarUser from '../NavbarUser';
import * as selectors from '../../../reducers';
import styles from './navbarSettings.css';


type NavbarSettingsPropTypes = {
  onLogout: Function
};

const NavbarSettings = ({ onLogout }: NavbarSettingsPropTypes) => (
  <PopMenu
    id="navbarSettings"
    vertical="below"
    horizontal="right"
    tipPosition="right"
    isRound
    options={[
      {
        Icon: MdExitToApp,
        title: 'Logout',
        onClick: onLogout,
      },
    ]}
  >
    <div className={styles.userSettings}>
      <NavbarUser />
      <NavbarButton className={styles.indicator} isOpaque hasSubmenu />
    </div>
  </PopMenu>
);


export default connect(
  state => ({ _persist: selectors.getPersist(state) }),
  dispatch => ({
    onLogout(_persist) {
      dispatch({
        ...jwtActions.logout(),
        state: { _persist },
      });
    },
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    onLogout: () => {
      dispatchProps.onLogout(stateProps._persist);
    },
  }),
)(NavbarSettings);



// WEBPACK FOOTER //
// ./src/scripts/components/Navbar/NavbarSettings/index.jsx